module.exports = __webpack_public_path__ + "img/sixpackcarrier101.fb8071c9.jpg";